import React from "react";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "ui/components/form";
import { Textarea } from "ui/components/textarea";

export const TextAreaItem = ({ control, name, label, disabled }) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <Textarea {...field} className="max-w-3xl min-h-28" disabled={disabled}/>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
